const GenderDefiner = (val: any) => {
  let definedData = null
  switch (val) {
    case 'Male':
      definedData = { label: 'Laki-laki', value: 'Male' }
      break
    case 'Female':
      definedData = { label: 'Perempuan', value: 'Female' }
      break
    default:
      break
  }

  return definedData
}

export default GenderDefiner